/* global Bugsnag */

const env = require('./env')

if (typeof Bugsnag !== "undefined") {
    Bugsnag.releaseStage        = env.stage
    Bugsnag.notifyReleaseStages = ["production"]
}



/** WEBPACK FOOTER **
 ** ./js/credentials/bugsnag.js
 **/